$(window).on('load', function () {
  initAffix();
});
$(document).ready(function () {
  window.addEventListener('resize', updateStickyMenuPositionOnDebouncedResize);
  $(".stickyMenuComponent-btnTrigger").click(function () {
    if (breakpoint.value === 'xs' || breakpoint.value === 'sm') {
      //on mobile devices we want the menu to collapse.
      $('#toggleBookmarks').collapse('toggle');
      $('.stickyMenuComponent-btnTrigger').toggleClass('is-expanded');
    }
  });
  if (!$('#features').length) {
    $('#featuresStickyItem').remove();
  }
  if (!$('#specifications').length) {
    $('#specificationsStickyItem').remove();
  }
  if (!$('#accessories').length) {
    $('#accessoriesStickyItem').remove();
  }
  if (!$('#documentation').length) {
    $('#documentationStickyItem').remove();
  }
  $('body').scrollspy({
    target: '#stickyMenuComponent-listWrapper',
    offset: getNavbarHeight() + getStickyMenuHeight()
  });
  $(".stickyMenuComponent-dealerLocatorLink").click(sendToDealerLocator);
});
function initAffix() {
  if (breakpoint.value === 'xs' || breakpoint.value === 'sm') {
    setStickyMenuPosition();
    scrollDistance();
  } else {
    $('#stickyMenuComponent').affix({
      offset: {
        top: getStickyMenuOffset() - getNavbarHeight()
      }
    });
  }
}
function sendToDealerLocator(e) {
  // Since the page will be torn down and all JS will be destroyed when clicking on a link,
  // we have to prevent the default action and redirect the user in the callback instead.
  e.preventDefault();
  var href = $(this).attr("href");
  var skuNmber = $(this).data("sku-number-for-tracking");
  gtag('event', 'dealer button', {
    'event_category': 'internal link',
    'event_label': skuNmber,
    'event_callback': loadPage(href)
  });
  var userReviewId = $(this).data("user-review-id-for-tracking");
  if (userReviewId && userReviewId !== "") {
    window.bvCallback = function (BV) {
      BV.pixel.trackConversion({
        'type': 'Find A Dealer',
        'value': userReviewId
      });
    };
  }
}
function loadPage(href) {
  window.location.assign(href);
}
function getStickyMenuOffset() {
  var offset = $("#stickyMenuComponent").offset();
  return offset.top;
}
function getStickyMenuHeight() {
  return $("#stickyMenuComponent").outerHeight();
}
function updateAffixTop() {
  $('#stickyMenuComponent').css("position", "static"); // Have to reset the position to get correct offset.
  $('#stickyMenuComponent').data('bs.affix').options.offset.top = getStickyMenuOffset() - getNavbarHeight();
  $('#stickyMenuComponent').removeAttr("style"); // Remove static position after calculation.
}
function scrollDistance() {
  if (breakpoint.value === 'xs' || breakpoint.value === 'sm') {
    $(document).scroll(function (e) {
      setStickyMenuPosition();
    });
  }
}
function setStickyMenuPosition() {
  if (breakpoint.value === 'xs' || breakpoint.value === 'sm') {
    //var mainHeaderHeight = $(".pageHeader").outerHeight();
    var mainHeaderHeight = $(".serviceMenu").outerHeight() + $(".breadcrumbsComponent").outerHeight();
    var scrollAmount = $(window).scrollTop();

    //console.log("mainHeaderHeight: " + mainHeaderHeight + "scrollAmount: " + scrollAmount);

    if (scrollAmount >= mainHeaderHeight) {
      $('#stickyMenuComponent').addClass("sticky");
    } else {
      $('#stickyMenuComponent').removeClass("sticky");
    }
  }
}
function getNavbarHeight() {
  var navbarHeight = $(".pageHeader").outerHeight(); // Get height of navbar (toolbar should be placed below it)
  return navbarHeight;
}
// Throttled window resize events
var updateStickyMenuPositionOnDebouncedResize = debounce(function () {
  //If mobile devices, check scroll offset and style the sticky menu instead of affixing it
  if (breakpoint.value === 'xs' || breakpoint.value === 'sm') {
    scrollDistance();
  } else {
    initAffix(); //we also need to init the affix if user changes viewport
    updateAffixTop();
  }
}, 250);